import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addMargincall } from "../../actions/MargincallActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';

class MargincallAddModal extends React.Component {

    constructor() {
        super();
        this.state = {
            margin: "",
            currency_id: "",
            currencyList:[],
            errors: {},
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.currencyList) {
            this.setState({
                currencyList: nextProps.currencyList
            })
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }
    onChange = e => {
        if (e.target.id === 'currency_id') {
            this.setState({ currency_id: e.target.value });
        }
        if (e.target.id === 'marginName') {
            this.setState({ margin: e.target.value });
        }
    };

    onMargincallAdd = e => {
        e.preventDefault();
        const newMargincall = {
            margin: this.state.margin,
            currency_id: this.state.currency_id
        };
        this.props.addMargincall(newMargincall, this.props.history);
    };
    showHtml = () => {
        const html = []
         this.state.currencyList.map(function (value, i) {
              html.push(
                     <>  
                         <option value={value.id}>{value.short_name}</option>
                     </>
                 );
             
     })
     return html;
     }
    render() {
        const { errors } = this.state;
        return (
            <div>
                <div className="modal fade" id="add-user-modal" data-reset="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Add Margin</h4>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                                <form noValidate onSubmit={this.onMargincallAdd} id="add-user">
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="currency_id">Currency Name</label>
                                        </div>
                                        <div className="col-md-9">
                                        <select className={classnames("form-control", {
                                                invalid: errors.currency_id
                                                })} id="currency_id" error={errors.currency_id} onChange={this.onChange} aria-label="Default select example">
                                                <option selected>Select Currency</option>
                                                 {this.showHtml()}
                                            </select>
                                           <span className="text-danger">{errors.currency_id}</span>
                                        </div>
                                    </div>
                                         <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Margin %</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.margin}
                                                id="marginName"
                                                type="number"
                                                error={errors.margin}
                                                className={classnames("form-control", {
                                                    invalid: errors.margin
                                                })}/>
                                            <span className="text-danger">{errors.margin}</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button
                                    form="add-user"
                                    type="submit"
                                    className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

MargincallAddModal.propTypes = {
    addMargincall: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { addMargincall }
)(withRouter(MargincallAddModal));
